import { AssessmentInsightsSummary } from "@/modules/assessments/types/insights.interface";

import { InsightsSummaryCard } from "./InsightsSummaryCard";
import style from "./insights-summary.module.css";
import { pluralize } from "@/shared/utils/pluralize";

interface InsightsSummaryRowProps {
  summary: AssessmentInsightsSummary;
}

export function InsightsSummaryRow({ summary }: InsightsSummaryRowProps) {
  const completionDisplay =
    summary.completionPercentage !== null && summary.completionPercentage !== undefined
      ? `${summary.completionPercentage}%`
      : "--";

  const totalStarted = summary.totalStarted ?? 0;
  const totalStartedDisplay = `${pluralize("Assessment", totalStarted)} Started`;
  const totalCompleted = summary.totalCompleted ?? 0;
  const totalCompletedDisplay = `${pluralize("Assessment", totalCompleted)} Completed`;

  return (
    <div className={style.summaryRow}>
      <InsightsSummaryCard title={totalStartedDisplay} value={totalStarted} />
      <InsightsSummaryCard title={totalCompletedDisplay} value={totalCompleted} />
      <InsightsSummaryCard title="Completion Rate" value={completionDisplay} />
    </div>
  );
}
